import styled from 'styled-components'

export const StyledMain = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: 2%;
    min-height: calc(100vh - 180px);
`
